import { P } from 'components'
import SvgIcon from 'components/Icon/SvgIcon'
import PMBTooltip from 'components/PMBTooltip'
import { useMemo } from 'react'
import CustomButton from './CustomButton'

const getHexColor = (colorName) => {
  switch (colorName) {
    case 'danger':
      return '#dc3545'
    case 'primary':
      return '#0d6efd'
    case 'success':
      return '#198754'
    case 'warning':
      return '#ffc107'
    case 'info':
      return '#0dcaf0'
    default:
      return colorName
  }
}

const ResponsiveActionButton = ({
  iconName = 'menu',
  label = 'Lihat',
  onClick,
  iconSize = 25,
  variant = 'outline',
  className = '',
  disabled = false,
  iconColor,
  testId = 'responsive-action-button',
}) => {
  const id = useMemo(
    () => `tooltip-${iconName}-${Math.random().toString(36).substring(2, 9)}`,
    [iconName],
  )
  const showTooltip = Boolean(label)

  const textColorClass = ['danger', 'success', 'warning', 'info', 'primary', 'secondary'].includes(
    iconColor,
  )
    ? `text-${iconColor}`
    : 'text-primary'

  return (
    <>
      <div className={`d-none d-sm-inline ${className}`}>
        <SvgIcon
          name={iconName}
          size={iconSize}
          onClick={onClick}
          color={getHexColor(iconColor)}
          disabled={disabled}
          id={showTooltip ? id : undefined}
          testId={testId}
        />
        {showTooltip && <PMBTooltip placement="top" target={id} text={label} />}
      </div>

      <div
        className={`d-inline d-sm-none ${textColorClass} text-sm ${className}`}
        onClick={onClick}
      >
        <CustomButton
          outline={variant === 'outline'}
          disabled={disabled}
          testId={testId}
        >
          <P size="small">{label}</P>
        </CustomButton>
      </div>
    </>
  )
}

export default ResponsiveActionButton
